import {Component} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {SpinnerComponent} from '../../svg/spinner/spinner.component';
import {AddOffer, AddProduct} from '@uofu-uss-aux/software-catalog-ng-core';
import {DownloadItemComponent} from '../download-list/download-item/download-item.component';
import {CatalogGraphicComponent} from '../../graphic/catalog-graphic/catalog-graphic.component';

@Component({
  selector: 'app-install-directions',
  standalone: true,
  imports: [CommonModule, SpinnerComponent, DownloadItemComponent, NgOptimizedImage, CatalogGraphicComponent],
  inputs: ['product', 'offer'],
  templateUrl: './install-directions.component.html',
  styleUrls: ['./install-directions.component.scss']
})
export class InstallDirectionsComponent extends AddProduct(AddOffer(Object)) {

  get installDirections(): string {
    return this.offer?.installDirections || '';
  }

}
